<template>
  <div class="container container-small">
    <div class="bottom-menu simple">
      <div class="row">
        <div class="col">
          <ul class="list-unstyled list-inline text-small">
            <li class="list-inline-item"><a href="#">Lorem</a></li>
            <li class="list-inline-item"><a href="#">Ipsum</a></li>
            <li class="list-inline-item"><a href="#">Lorem</a></li>
            <li class="list-inline-item"><a href="#">Ipsum</a></li>
          </ul>
        </div>
        <div class="col-auto ms-auto">
          <div class="social-links">
            <div class="row">
              <div class="col text-end">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a href="#">
                      <i class="bi bi-facebook"></i> </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="#">
                      <i class="bi bi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="#">
                      <i class="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="#">
                      <i class="bi bi-instagram"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a href="#">
                      <i class="bi bi-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coop">
      <div class="row">
        <div class="col text-center">
          <ul class="list-inline">
            <li class="list-inline-item">
              <a href="#" title="Biuletyn Informacji Publicznej">
                <img src="/images/logos-bip.png" alt=""/>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="#" title="Infrastruktura i Środowisko - Narodowa Strategia Spójności">
                <img src="/images/logos-nss.png" alt=""/>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="#" title="Unia Europejska - Funduszu Spójności">
                <img src="/images/logos-ue.png" alt=""/>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'section-footer-simple',
  data() {
    return {}
  }
}
</script>